export default __webpack_public_path__ + "static/media/Homepage.60fdac83.png";